import React from 'react'
import Exhibitions from './Exhibitions';
import MyTabs from '../../../components/MyTabs';

const BodyOfWork = () => {
    const tabs = [
        { id: "exhibitions", title: "Exhibitions", Component: Exhibitions },
      ];

return (
    <>
        <MyTabs list={tabs}/>
    </>
)
}

export default BodyOfWork